import type { Template } from "@/types";

export const LA_06_H6_V0: Template[] = [
{
    id: "la-06-h6v0-01",
    name: "LA 01 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 101, y: 36, width: 415, height: 259, rotation: 0, imageRotation: 0 },
            { id: "2", x: 101, y: 302, width: 204, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 313, y: 302, width: 204, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 757, y: 36, width: 415, height: 259, rotation: 0, imageRotation: 0 },
            { id: "5", x: 757, y: 302, width: 204, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 969, y: 302, width: 204, height: 138, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h6v0-02",
    name: "LA 02 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 101, y: 36, width: 415, height: 259, rotation: 0, imageRotation: 0 },
            { id: "2", x: 101, y: 302, width: 204, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 313, y: 302, width: 204, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 757, y: 181, width: 415, height: 258, rotation: 0, imageRotation: 0 },
            { id: "5", x: 757, y: 36, width: 204, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 969, y: 36, width: 204, height: 138, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h6v0-03",
    name: "LA 03 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 194, y: 0, width: 249, height: 154, rotation: 0, imageRotation: 0 },
            { id: "2", x: 194, y: 161, width: 249, height: 154, rotation: 0, imageRotation: 0 },
            { id: "3", x: 194, y: 322, width: 249, height: 154, rotation: 0, imageRotation: 0 },
            { id: "4", x: 831, y: 0, width: 249, height: 154, rotation: 0, imageRotation: 0 },
            { id: "5", x: 831, y: 161, width: 249, height: 154, rotation: 0, imageRotation: 0 },
            { id: "6", x: 831, y: 322, width: 249, height: 154, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h6v0-04",
    name: "LA 04 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 36, y: 23, width: 319, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 36, y: 241, width: 319, height: 211, rotation: 0, imageRotation: 0 },
            { id: "3", x: 362, y: 23, width: 662, height: 428, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1032, y: 23, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1032, y: 169, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1032, y: 314, width: 207, height: 137, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h6v0-05",
    name: "LA 05 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 35, y: 23, width: 319, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 35, y: 241, width: 319, height: 211, rotation: 0, imageRotation: 0 },
            { id: "3", x: 361, y: 23, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 361, y: 168, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 361, y: 313, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 576, y: 23, width: 662, height: 428, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h6v0-06",
    name: "LA 06 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 36, y: 24, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "2", x: 36, y: 169, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 36, y: 314, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 250, y: 24, width: 319, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 250, y: 242, width: 319, height: 212, rotation: 0, imageRotation: 0 },
            { id: "6", x: 575, y: 24, width: 663, height: 428, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h6v0-07",
    name: "LA 07 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 97, y: 43, width: 300, height: 192, rotation: 0, imageRotation: 0 },
            { id: "2", x: 97, y: 242, width: 300, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 403, y: 43, width: 582, height: 390, rotation: 0, imageRotation: 0 },
            { id: "4", x: 992, y: 43, width: 184, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 992, y: 176, width: 184, height: 125, rotation: 0, imageRotation: 0 },
            { id: "6", x: 992, y: 308, width: 184, height: 125, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h6v0-08",
    name: "LA 08 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 92, width: 209, height: 143, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 242, width: 209, height: 143, rotation: 0, imageRotation: 0 },
            { id: "3", x: 216, y: 92, width: 417, height: 292, rotation: 0, imageRotation: 0 },
            { id: "4", x: 641, y: 92, width: 209, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 641, y: 242, width: 209, height: 143, rotation: 0, imageRotation: 0 },
            { id: "6", x: 857, y: 92, width: 417, height: 292, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h6v0-09",
    name: "LA 09 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 92, width: 417, height: 292, rotation: 0, imageRotation: 0 },
            { id: "2", x: 425, y: 92, width: 209, height: 143, rotation: 0, imageRotation: 0 },
            { id: "3", x: 425, y: 242, width: 209, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 92, width: 208, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 242, width: 208, height: 143, rotation: 0, imageRotation: 0 },
            { id: "6", x: 857, y: 92, width: 417, height: 292, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h6v0-10",
    name: "LA 10 - H6V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 91, width: 209, height: 143, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 241, width: 209, height: 143, rotation: 0, imageRotation: 0 },
            { id: "3", x: 217, y: 91, width: 417, height: 292, rotation: 0, imageRotation: 0 },
            { id: "4", x: 641, y: 91, width: 417, height: 292, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1065, y: 91, width: 209, height: 143, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1065, y: 241, width: 209, height: 143, rotation: 0, imageRotation: 0 }
    ],
}
];